import { ReactElement, useEffect, useRef } from 'react';
import { HeapMaskOverlay, hexToRgb } from './heapMasks';

interface HeapSegmentationOverlayProps {
  overlay: HeapMaskOverlay;
  renderedWidth: number;
  renderedHeight: number;
}

export function HeapSegmentationOverlay({
  overlay,
  renderedWidth,
  renderedHeight,
}: HeapSegmentationOverlayProps): ReactElement {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const { bitmap, color, opacity } = overlay;

  useEffect(() => {
    const context = canvasRef.current?.getContext('2d');
    if (!context) return;

    const { width, height, pixels } = bitmap;
    const imageData = context.createImageData(width, height);
    const data = imageData.data;
    const [red, green, blue] = hexToRgb(color);

    for (let position = 0; position < pixels.length; position++) {
      if (pixels[position] === 0) continue;
      const offset = position * 4;
      data[offset] = red;
      data[offset + 1] = green;
      data[offset + 2] = blue;
      data[offset + 3] = 255;
    }

    context.putImageData(imageData, 0, 0);
  }, [bitmap, color]);

  return (
    <canvas
      ref={canvasRef}
      width={bitmap.width}
      height={bitmap.height}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: renderedWidth,
        height: renderedHeight,
        opacity,
        pointerEvents: 'none',
        borderRadius: '10px',
      }}
    />
  );
}
